module.exports = __webpack_public_path__ + "img/bether_gem_hq.c905ef59.png";